// Fold only settled, read-only exploration. Keep the original receipts and
// chronology intact; failures, mutations, narration and live calls are barriers.
const EXPLORATION = new Set(['project_read', 'project_list', 'project_search',
  'git_status', 'git_diff', 'document_info', 'document_extract', 'document_inspect', 'read_collection_file']);

function summary(rows) {
  const files = new Set();
  let searches = 0, folders = 0;
  for (const { line } of rows) {
    const tool = line.part.tool, input = line.part.state?.input || {}, path = input.path;
    const filenameQuery = tool === 'project_list' && typeof input.query === 'string'
      && input.query.length >= 1 && input.query.length <= 200 && !/[\u0000-\u001f\u007f]/.test(input.query);
    if (tool === 'project_search' || filenameQuery) searches++;
    else if (tool === 'project_list') folders++;
    else if (tool === 'project_worktree' && input.operation === 'read' && path) files.add(`worktree:${input.worktreeId}/${path}`);
    else if (tool === 'read_collection_file' && input.fileId) files.add(`collection:${line.part.state.metadata?.collectionId}/${input.fileId}`);
    else if (['project_read', 'document_extract', 'document_inspect'].includes(tool) && path) files.add(path);
  }
  const labels = [];
  if (files.size) labels.push(`Read ${files.size} ${files.size === 1 ? 'file' : 'files'}`);
  if (searches) labels.push(`${searches} ${searches === 1 ? 'search' : 'searches'}`);
  if (folders) labels.push(`${folders} folder ${folders === 1 ? 'listing' : 'listings'}`);
  return labels.join(' · ') || 'Explored the project';
}

export function groupCompletedWorkActivity(keyed) {
  const result = [];
  let pending = [];
  const flush = () => {
    if (pending.length >= 3) result.push({ key: `exploration:${pending[0].key}`,
      lines: pending.map(row => row.line), summary: summary(pending) });
    else result.push(...pending);
    pending = [];
  };
  for (const row of keyed) {
    if (row.line.kind === 'tool' && row.line.status === 'completed'
        && !row.line.isError && !row.line.isIncomplete && (EXPLORATION.has(row.line.part?.tool)
          || row.line.part?.tool === 'project_worktree' && row.line.part.state?.input?.operation === 'read')) pending.push(row);
    else { flush(); result.push(row); }
  }
  flush();
  return result;
}
